import videojs, { VideoJsPlayer } from 'video.js';

export function attachPluginToPlayer(
  plugin: videojs.Plugin,
  player: VideoJsPlayer
) {
  const attach = () => {
    // override the plugin instance getter https://github.com/videojs/video.js/blob/f080150e87f115e5ba26adbab82e1f043588037d/src/js/plugin.js#L166
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    player[plugin.name] = plugin;
  };
  player.on(`pluginsetup:${plugin.name}`, attach);
  plugin.on('dispose', () => {
    player.off(`pluginsetup:${plugin.name}`, attach);
  });
}
